export default __webpack_public_path__ + "static/media/logo-umid-white.84a40074.png";